export interface IFirebaseReadFromCollectionParams {
  injectId?: boolean;
}
